const defaultConfig = {
  titleKey: "multi_cards_title",
  descriptionKey: "multi_cards_description",
  itemsKey: "multi_cards",
};

/**
 *
 * @param page
 * @param config
 * @param props
 * @returns {{component: string, props: (*&{title: (*|null), items: *})}|null}
 */
export const multiCards = ({ page, config, ...props }) => {
  config = Object.assign({}, defaultConfig, config);

  if (!page || !(config.itemsKey in page) || page[config.itemsKey].length === 0) {
    return null;
  }

  return {
    component: "MultiCards",
    props: {
      title: page[config.titleKey] ?? null,
      description: page[config.descriptionKey] ?? null,
      items: page[config.itemsKey].map((i) => ({
        title: i.title ?? null,
        img: i.image ?? "",
        href: i.link ?? null,
      })),
      ...props,
    },
  };
};
